import React from 'react';
import './style.scss';
import { isMobileFun, createFilePath, convertStylesStringToObject } from '../../utils/obj-utils';

export default function index(props) {
  const isMobile = isMobileFun();
  const { img, linkUrl, m_img, returnIcon, pc_flag, m_flag, headerstyle, m_headerstyle, logostyle, m_logostyle } = props.fields;
  return (
    <>
      {headerstyle?.value || m_headerstyle?.value ? (
        <div
          className={`${!isMobile ? 'operation_header' : 'operation_header_m'}`}
          style={convertStylesStringToObject(isMobile ? m_headerstyle?.value : headerstyle?.value)}
        >
          <img
            alt="广汽本田"
            src={createFilePath(!isMobile ? img.value : m_img.value)}
            style={convertStylesStringToObject(isMobile ? m_logostyle?.value : logostyle?.value)}
          />
        </div>
      ) : (
        <div
          className={`${!isMobile ? 'operation_header' : 'operation_header_m'}`}
          style={{ display: !isMobile && pc_flag.value ? 'block' : isMobile && m_flag.value ? 'grid' : 'none' }}
        >
          <img alt="广汽本田" src={createFilePath(!isMobile ? img.value : m_img.value)} />
        </div>
      )}
    </>
  );
}
